import Vue from 'vue';
import App from './App.vue';
import router from './router';

import config from '../config';

import iView from 'iview';
import 'iview/dist/styles/iview.css';
import locale from 'iview/dist/locale/ru-RU';

import firebase from "firebase/app";

firebase.initializeApp(config.firebase);

Vue.use(iView, { locale });

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
